import React from "react";
import { BsPencilSquare } from "react-icons/bs";

function EditButton({ onclick }) {
  return (
    <button
      className="mr-3 text-teal-500 duration-300 ease-in-out hover:text-teal-900 "
      onClick={onclick}
    >
      <BsPencilSquare className="w-4 h-4" />
    </button>
  );
}

export default EditButton;
